import { AvvirRoutingEvent } from "type_aliases";
import PageNames from "../../models/domain/enums/page_names";

export type ToCustomReportsEvent = AvvirRoutingEvent<typeof TO_CUSTOM_REPORTS, {
  projectId: string
  embedded?: boolean,
  pageName: PageNames,
  reportsBase?: "summary" | "reports"
}>

const toCustomReports = (
  projectId: string, embedded?: boolean, pageName?: PageNames, reportsBase: "summary" | "reports" = "summary"
): ToCustomReportsEvent => ({
  type: TO_CUSTOM_REPORTS,
  payload: {
    projectId,
    pageName: pageName || PageNames.PROJECT_SUMMARY,
    reportsBase,
    embedded,
  }
});

export const TO_CUSTOM_REPORTS = "to_custom_reports";

export default toCustomReports;
